import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class PageService {
  constructor(@Inject(DOCUMENT) private readonly document: Document) {}
}
